export const InvalidDate = 'Una delle date inserite non è nel formato valido! Riprovare'